// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wuG8","rootNoMargin":"styles_rootNoMargin__3TzeC"};